import React from 'react';

import { IconExclamation } from '@/components/apps/ui/icon';

import theme from '@/styles/theme';

import BadgeIcon from '../badge/BadgeIcon';

type VariantType = 'default' | 'error';

interface Props {
  type?: VariantType;
  text?: React.ReactNode;
  showBadgeIcon?: boolean;
  className?: string;
}

const TYPE_CLASS: Record<VariantType, string> = {
  default: 'text-apps-coreGray02',
  error: 'text-apps-coreProductError01',
};

export default function NoticeCaption({
  type = 'default',
  text,
  showBadgeIcon = false,
  className,
}: Props) {
  return (
    <span
      className={`flex items-start gap-1 text-sm font-normal leading-[140%] tracking-[-0.28px] ${TYPE_CLASS[type]} ${className ?? ''}`}
    >
      <span className="pt-1">
        {showBadgeIcon && type === 'default' && (
          <BadgeIcon
            size="sm"
            color="gray"
            icon={
              <IconExclamation
                size={12}
                color={theme`colors.apps.coreGrayBlack`}
              />
            }
          />
        )}
        {type === 'error' && ( // type: error 일 때, BadgeNotice 컴포넌트 항상 노출
          <BadgeIcon
            size="sm"
            color="error"
            icon={
              <IconExclamation
                size={12}
                color={theme`colors.apps.coreGrayBlack`}
              />
            }
          />
        )}
      </span>
      {text}
    </span>
  );
}
